// Class: motion.easing.LinearEaseNone

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../motion/easing/IEasing");}

// Constructor

var LinearEaseNone = function() {
}

// Meta

LinearEaseNone.__name__ = ["motion","easing","LinearEaseNone"];
LinearEaseNone.__isInterface__ = false;
LinearEaseNone.__interfaces__ = [(motion_easing_IEasing().default)];
LinearEaseNone.prototype = {
	calculate: function(k) {
		return k;
	},
	ease: function(t,b,c,d) {
		return c * t / d + b;
	}
};
LinearEaseNone.prototype.__class__ = LinearEaseNone.prototype.constructor = $hxClasses["motion.easing.LinearEaseNone"] = LinearEaseNone;

// Init



// Statics




// Export

exports.default = LinearEaseNone;